import {ID} from '~/lib/model';

export const usersLinks = {
    users: () => '/users',
    user: (userId: ID) => `/users/${userId}`
};
